import { MedRecSwitch, SearchHeader, StoreLocator } from '@/components';

import {
  HeaderFavorites,
  HeaderLogo,
  HeaderNav,
  HeaderProfile,
  HeaderRow,
  HeaderSection,
  HeaderShopping,
} from '../../Header.components';

import styles from './withTopLocatorAndBottomNav.module.scss';

const HeaderWithTopLocatorAndBottomNavDesktop = () => (
  <>
    <HeaderRow className={styles.search__header_top_row} type="small">
      <HeaderSection justify="start">
        <StoreLocator />
        <MedRecSwitch />
      </HeaderSection>
      <HeaderSection justify="end">
        <HeaderProfile showLabel />
        <HeaderFavorites showLabel />
      </HeaderSection>
    </HeaderRow>
    <HeaderRow
      className={styles.search__header_center_row}
      relativePosition
      type="small"
    >
      <HeaderSection justify="start">
        <HeaderLogo fullWidth />
      </HeaderSection>
      <HeaderSection justify="end">
        <SearchHeader className={styles.search__header} />
        <HeaderShopping />
      </HeaderSection>
    </HeaderRow>
    <HeaderRow type="flat" withNavbar>
      <HeaderSection justify="start">
        <HeaderNav />
      </HeaderSection>
    </HeaderRow>
  </>
);

export { HeaderWithTopLocatorAndBottomNavDesktop };
